import { render, staticRenderFns } from "./CamerasStats.vue?vue&type=template&id=53c31394&scoped=true"
import script from "./CamerasStats.vue?vue&type=script&lang=ts"
export * from "./CamerasStats.vue?vue&type=script&lang=ts"
import style0 from "./CamerasStats.vue?vue&type=style&index=0&id=53c31394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c31394",
  null
  
)

export default component.exports